import { Action } from '@thoughtspot/visual-embed-sdk'

export const ENV_PRODUCTON = 'production'
export const ENV_DEVELOPMENT = 'development'
export const ENV_LOCAL = 'local'
export const ENV_LOCAL_TEST = 'local-test'

export const TEST_ORG_DATA_SOURCE_GUID = '5780dfbf-290d-332b-9e36-2cdd87a75bc4'

const environment = import.meta.env.VITE_REACT_APP_SENTRY_ENVIRONMENT
export const IS_PRODUCTION = environment === ENV_PRODUCTON

// Used when initializing ThoughtSpot SDK
export const TS_STRING_REPLACEMENTS = {
  'Liveboards': 'Dashboards',
  'liveboards': 'dashboards',
  'Liveboard': 'Dashboard',
  'liveboard': 'dashboard',
  'Answers': 'Visualisations',
  'answers': 'visualisations',
  'Answer': 'Visualisation',
  'answer': 'visualisation',
  'Spotter': 'Ask AI',
  'SpotIQ': 'InsightIQ',
  'Search your data': 'Create a visual',
  'an alert': 'a subscription',
  'Alert': 'Subscription',
  'Alerts': 'Subscriptions',
  'alert': 'subscription',
  'alerts': 'subscriptions',
}

const TS_PRODUCTION_ONLY_CSS = {
  // Hides the error details from the user
  '.muted-alert-module__actionButtons': {
    'display': 'none',
  },
}

const TS_ALL_ENVIRONEMENT_CSS = {
  // adds margin to the library header for visualisations and dashboards
  '.library-header-module__libraryHeader': {
    'margin-left': '24px !important',
    'margin-top': '12px !important',
  },
  '[data-testid="filter-panel-chip"][data-tooltip-content*="Value:"]': {
    //  if "Value:" exists in the tooltip content
    '--ts-var-chip-background': '#D8EFFD',
    '--ts-var-chip-color': '#00588F',
  },
}

const rules_UNSTABLE = IS_PRODUCTION
  ? {
      ...TS_PRODUCTION_ONLY_CSS,
      ...TS_ALL_ENVIRONEMENT_CSS,
    }
  : {
      ...TS_ALL_ENVIRONEMENT_CSS,
    }

export const TS_CUSTOM_STYLE_BLOCK = {
  customCSS: {
    rules_UNSTABLE,
  },
}

export const TS_ICON_SPRITE_PATH = 'icons/thoughtspotSpritesheet.svg'
export const HF_ANALYTICS_LOGO_LIGHT_BACKGROUND_PATH = 'brand/humanforce-intelligence-blue.png'
export const HF_ANALYTICS_LOGO_DARK_BACKGROUND_PATH = 'brand/humanforce-intelligence-yellow.png'
export const HF_ANALYTICS_LOGO_HUMANFORCE_MONOGRAM_PATH = 'brand/humanforce-monogram.png'

const TML_ACTIONS_LIST = [Action.EditTML, Action.ImportTML, Action.ExportTML, Action.UpdateTML]
const HIDDEN_DASHBOARD_ACTIONS = TML_ACTIONS_LIST
const HIDDEN_VISUALISATION_ACTIONS = [Action.CopyLink, Action.ManagePipelines]
export const HIDDEN_CREATE_VISUAL_ACTIONS = [
  Action.AddFormula,
  Action.AddParameter,
  Action.QueryDetailsButtons,
  Action.ManagePipelines,
].concat(TML_ACTIONS_LIST)

const INSIGHTS_ACTIONS = [
  Action.SpotIQAnalyze,
  Action.SpotIQFollow,
  Action.ExplainInsight
]

export const ALL_HIDDEN_ACTIONS = [
  ...new Set([...HIDDEN_DASHBOARD_ACTIONS, ...HIDDEN_VISUALISATION_ACTIONS, ...HIDDEN_CREATE_VISUAL_ACTIONS, ...INSIGHTS_ACTIONS]),
]

export const COMMON_THOUGHTSPOT_ACTIONS = {
  // redirects to custom links set in Links Settings of TS
  linkOverride: true,
  // hides the url when hovering over a link
  disableRedirectionLinksInNewTab: true,
}

export const ERROR_404_ROUTE = '/error404'
